<template>
  <div>
    <div class="mb-12 flex w-full flex-col text-center md:mb-20">
      <p class="mb-3 text-sm font-medium uppercase tracking-wider text-primary">
        {{ $t('landing.steps.howItWorks') }}
      </p>
      <h2
        class="mx-auto text-3xl font-bold text-gray-900 tracking-tight md:text-5xl"
      >
        {{ $t('landing.steps.threeStepsTitle') }}
      </h2>
    </div>

    <div class="flex flex-col justify-center gap-6 items-center lg:flex-row">
      <LandingHowItWorksCard
        image-src="/images/step-topics.png"
        :image-alt="$t('landing.steps.step1Title')"
      >
        <template #title>{{ $t('landing.steps.step1Title') }}</template>
        <template #description>{{ $t('landing.steps.step1Description') }}</template>
      </LandingHowItWorksCard>

      <LandingHowItWorksArrow />

      <LandingHowItWorksCard
        is-capybara
        image-src="/images/step-exercise.png"
        :image-alt="$t('landing.steps.step2Title')"
      >
        <template #title>{{ $t('landing.steps.step2Title') }}</template>
        <template #description>{{ $t('landing.steps.step2Description') }}</template>
      </LandingHowItWorksCard>

      <LandingHowItWorksArrow />

      <LandingHowItWorksCard
        image-src="/images/step-explanation.png"
        :image-alt="$t('landing.steps.step3Title')"
      >
        <template #title>
          {{ $t('landing.steps.step3Title') }} <span class="bg-success/25">{{ $t('landing.steps.step3TitleHighlight') }}</span>
        </template>
        <template #description>{{ $t('landing.steps.step3Description') }}</template>
      </LandingHowItWorksCard>
    </div>
  </div>
</template>

<script>
import LandingHowItWorksCard from '@/components/Landing/LandingHowItWorksCard.vue'
import LandingHowItWorksArrow from '@/components/Landing/LandingHowItWorksArrow.vue'

export default {
  name: 'LandingHowItWorks',

  components: { LandingHowItWorksCard, LandingHowItWorksArrow }
}
</script>
